/* @flow */

export default class ChangeEmailRequest {
  email: string;
  newEmail: string;
}
